import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { RESIZE_URL } from 'utils/restapi';
import { patchCustomTheme } from 'redux/themes/actions';
import { fetchMe } from 'redux/users/actions';

import CommonImageDropzone from 'components/common/CommonImageDropzone';

import ProFeaturePlaceholder
  from 'components/common/ProFeaturePlaceholder';

import './BackgroundImageSelector.css';

class BackgroundImageSelector extends Component {
  static propTypes = {
    patchCustomTheme: PropTypes.func.isRequired,
    setCustomMode: PropTypes.func.isRequired,
    me: PropTypes.object,
  };

  static defaultProps = {
    me: null,
  };

  state = {
    showLoader: false,
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.me.custom_theme.background_image !==
      this.props.me.custom_theme.background_image
    ) {
      setTimeout(() => {
        this.setState({ showLoader: false });
      }, 500);
    }
  }

  _onImageDrop = droppedImage => {
    const { me } = this.props;
    const customThemeId = me && me.custom_theme && me.custom_theme.id;

    if (me.theme) { this.props.setCustomMode(); }
    const form = new FormData();
    form.append('background_image', droppedImage.imageBlob, droppedImage.name);
    form.append('background_animated_style', '');
    this.props.patchCustomTheme(customThemeId, form);

    this.setState({ showLoader: true });
  };

  _onImageRemove = () => {
    const { me } = this.props;
    const customThemeId = me && me.custom_theme && me.custom_theme.id;
    const form = new FormData();
    form.append('background_image', '');
    this.props.patchCustomTheme(customThemeId, form);
  };

  render() {
    const { me } = this.props;
    const { showLoader } = this.state;

    if (!me) return null;
    const currentImage = me && me.custom_theme &&
      me.custom_theme.background_image;

    return (
      <ProFeaturePlaceholder
        key="background-image-selector-pro-feature-key"
        proLabel
        locked={me && me.subscription && !me.subscription.ff_background_image}
        className="background-image-selector__component"
      >
        <div
          className="dropzone-wrapper"
          style={{ backgroundImage: currentImage && `url(${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=96/${currentImage})` }}
        >
          {currentImage &&
            <div
              className="delete-icon"
              onClick={this._onImageRemove}
              role="button"
              tabIndex={-1}
            />
          }

          {currentImage && <div className="active-picture" />}

          <CommonImageDropzone
            onDropImage={this._onImageDrop}
            className="upload-dropzone"
            modalClassName="background-image-upload-dropzone"
            loading={showLoader}
            noClick={currentImage}
            aspectRatio={16 / 9}
          />
        </div>
      </ProFeaturePlaceholder>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCustomTheme,
    fetchMe,
  },
)(BackgroundImageSelector);
